import apiService from '../apiService';

const E_SIGNATURE_URL = 'documents/e-sign';

const eSignatureService = {
    async uploadDocForSignature(payload) {
        try {
            const response = await apiService.post(`/${E_SIGNATURE_URL}/send`, payload);
            return response.data;
        } catch (error) {
            throw error.response;
        }
    },

    /** OL-150: combine several PDFs into one packet; resolves to the combined PDF as a Blob. */
    async combineDocuments(files) {
        const formData = new FormData();
        files.forEach((file) => formData.append('files[]', file));
        try {
            const response = await apiService.post(`/${E_SIGNATURE_URL}/merge`, formData, { responseType: 'blob' });
            return response.data;
        } catch (error) {
            throw error.response;
        }
    },

    async getDocumentsForSignature(id) {
        try {
            const response = await apiService.get(`/${E_SIGNATURE_URL}/document/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async uploadSignedDocument(token, payload) {
        try {
            const response = await apiService.post(`/${E_SIGNATURE_URL}/sign/${token}`, payload);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async getRecipientSigners(type, id) {
        try {
            const response = await apiService.get(`/${E_SIGNATURE_URL}/recipients/${type}/${id}/signers`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async downloadSignDocument(id, type = 'download') {
        try {
            // setShowDocumentPreviewModal(true)
            const response = await apiService.get(`/${E_SIGNATURE_URL}/document/${id}/${type}`, { responseType: 'blob' });
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },


    async resendUploadedDocument(id) {
        try {
            const response = await apiService.post(`/${E_SIGNATURE_URL}/resend/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    /** OL-204: one prepared document to many contacts; resolves with the group send's id. */
    async sendToMany(payload) {
        try {
            const response = await apiService.post(`/${E_SIGNATURE_URL}/send-many`, payload);
            return response.data;
        } catch (error) {
            throw error.response;
        }
    },

    /** OL-205: one group send with each recipient's progress. */
    async getBatch(id) {
        try {
            const response = await apiService.get(`/${E_SIGNATURE_URL}/batches/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async remindDocument(id) {
        try {
            const response = await apiService.post(`/${E_SIGNATURE_URL}/remind/${id}`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },

    async remindBatch(id) {
        try {
            const response = await apiService.post(`/${E_SIGNATURE_URL}/batches/${id}/remind`);
            return response.data;
        } catch (error) {
            throw error.response.data;
        }
    },
};

export default eSignatureService;